import { styled } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow';

const StyledMuiTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
    color: '#4B576B',
  },
  '&:nth-of-type(even)': {
    color: '#4B576B',
  },
}));

export default StyledMuiTableRow;